import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation } from '@tanstack/react-query'
import { QueryKey } from '../../domain/enums/query-keys'
import { DeactivateSubscription } from '../../usecases/deactivate-subscription'

export const useDeactivateSubscription = () => {
  const container = useContainer()

  return useMutation(
    [QueryKey.deactivateSubscription],
    (id: string) => new DeactivateSubscription(container.get(HttpClient)).execute(id),
    {
      retry: false,
    },
  )
}
